module.exports = {"321081100":"真州镇","321081103":"新集镇","321081104":"新城镇","321081105":"马集镇","321081106":"刘集镇","321081107":"陈集镇","321081108":"大仪镇","321081109":"月塘镇","321081150":"青山镇","321081401":"原种场","321081402":"蚕种场","321081403":"园艺试验场","321081404":"水产试验场","321081405":"捺山茶场","321081407":"汽车工业园","321081410":"开发区","321081412":"枣林湾旅游度假区","321081454":"化学工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/321081.json
// module id = 919
// module chunks = 0